import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/relatorio-viagem-data`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms = {}) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getMunicipios(queryParms = {}) {
            return repository.get(`${baseUrl}/municipio?${urlUtil.serialize(queryParms)}`)
        },
        getMotoristas(queryParms = {}) {
            return repository.get(`${baseUrl}/motorista?${urlUtil.serialize(queryParms)}`)
        },
        getDestinos(queryParms = {}) {
            return repository.get(`${baseUrl}/destino?${urlUtil.serialize(queryParms)}`)
        },
        getStatus(queryParms = {}) {
            return repository.get(`${baseUrl}/status?${urlUtil.serialize(queryParms)}`)
        },
    }
}